import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSyncAlt } from '@fortawesome/free-solid-svg-icons'
import {callback} from '../../../helpers.js';
import PopupRowSelector from '../../farm/field/PopupRowSelector.js';
import IntInput from '../../forms/IntInput.js';
import PieceRateInput from '../../forms/PieceRateInput.js';

import api from '../../../api/index.js';


const RaspberryPieceRateTask = (props) => {
	console.log(props);

/*	
	const onRowsChange = (selected) => {
		console.log("RaspberryPieceRate rows changed");

		callback(props.onChange, [{
			'rows': selected,
			'amount': props.data.amount
			'associated_data': props.data.associated_data
		}]);
	}

	const onPlantsChange = (e) => {
		console.log(e);
		callback(props.onChange, [{
			'rows': props.data.rows,
			'amount': e.target.value,
			'associated_data': null,
		}]);
	}*/

	const onChange = (text, amount) => {
		console.log(text, amount);
		
		callback(props.onChange, [{
			'rows': props.data.rows,
			'amount': amount,
			'text': text,
		}]);
	}
/*
	const recalculate = async (e) => {
		e.preventDefault();
	// We want to calculate the plants, don't we?... If the rows, change, or if plants are null?
	// Maybe this should be explicit... You have to click the refresh button... It'd be nice if the on change sent back the calculated plants.. though we'd have to save that on the backend too
	// Maybe best to just calculate it...
	
		try {
			const fields = await api.getsoft('fields/' + props.field);
			if (fields.length !== 1) {
				api.error("Couldn't retrieve data for field ID " + props.field);
				return;
			}
			const f = fields[0];

			let rowdata = await api.getsoft('farms/' + f.FarmID + '/fields/' + f.FieldID + '/rows?from=' + props.date.api() + '&until=' + props.date.api() );
			
			console.log("f", f);
			console.log("row", rowdata);
			
			let plants = 0;
			for(let i=0; i < props.data.rows.length; i++) {
				let rowID = props.data.rows[i];
				for(let t=0; t < rowdata.length; t++) {
					let r = rowdata[t];
					if (r.RowID == rowID) {
						plants += (r.RowLength/f.PlantSpacing) - r.DeadPlantNum;
					}
				}
			}
			onPlantsChange({'target': {'value': Math.ceil(plants)}});
			
		} catch(e) {
			api.handleExceptions(e);
		};
	

	}
*/
//		<PopupRowSelector date={props.date} field={props.field} rows={props.data.rows} onSubmit={onRowsChange} />
//		<IntInput name="plants" value={props.data.amount} placeholder="Number of plants" onChange={onPlantsChange} />
// 		<button className="block plus" onClick={recalculate} title="Calculate plants from the selected rows"><FontAwesomeIcon icon={faSyncAlt} /></button>

	return <span>
		<PieceRateInput text={props.data.text} onChange={onChange} />
	</span>;
}

RaspberryPieceRateTask.getdataformat = () => {
	return {
		'rows': [],
		'amount': 0, // plants
		'text': null,
	}
};



export default RaspberryPieceRateTask;